import { consoleLoggerFactory, getDefaultLoggerOptions, type ILogger, LogLevels } from "@/types/console-logger";
const logger: ILogger = consoleLoggerFactory.create( getDefaultLoggerOptions( LogLevels.ERROR ) );

export type VersionInfo = {
    breaking: number,
    feature: number,
    fix: number
}

export function useVersionInfo() {
    const currentVersion: string = __APP_VERSION__;

    return {
        currentVersion
    };
}

export function isNewerVersionAvailable( latestVs: string ): boolean {
    const latestVersion: VersionInfo = parseVersion( latestVs );
    const { currentVersion } = useVersionInfo();
    const clientVersion: VersionInfo = parseVersion( currentVersion );

    if ( latestVersion.breaking <= clientVersion.breaking ) {
        if ( latestVersion.feature <= clientVersion.feature ) {
            if ( latestVersion.fix <= clientVersion.fix ) {
                logger.debug( 'Newer version IS NOT available.' );
                return false;
            }
        }
    }

    logger.error( 'Newer version IS available.' );
    return true;
}

function parseVersion( vs: string ): VersionInfo {
    const tokens: string[] = vs.split( '.' );
    return {
        breaking: parseInt( tokens[ 0 ] ),
        feature: parseInt( tokens[ 1 ] ),
        fix: parseInt( tokens[ 2 ] )
    }
}
